<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <dropdown :class="['mr-1']" width="180px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :label-color="$dark ? 'white' : 'black'" :label-color-lightness="null" v-model="legendAlign" :items="legendAlignOptions"  /><!--
          --><dropdown :class="['mx-1']" width="180px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :label-color="$dark ? 'white' : 'black'" :label-color-lightness="null" v-model="contentAlign" :items="contentAlignOptions"  /><!--
          --><checkbox label-size="xs" :label="$lang.legend" v-model="legend" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" :label="$lang.rounded" v-model="rounded" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <async-form :form-data="formData">
          <form-group :rounded="rounded" :content-align="contentAlign[0]" :legend-align="legendAlign[0]" :legend="legend ? $lang.titleAndName : null">
            <dropdown icon="human-greeting" :label="$lang.title" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :label-color="$dark ? 'white' : 'black'" :label-color-lightness="null" v-model="formData.title" :items="titles"  />
            <text-field icon-left="account" :label-color="$dark ? 'white' : 'black'" v-model="formData.firstName" :label="$lang.firstName" :placeholder="$lang.firstName" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
            <text-field icon-left="account" :label-color="$dark ? 'white' : 'black'" v-model="formData.lastName" :label="$lang.lastName" :placeholder="$lang.lastName" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
          </form-group>
          <form-group :rounded="rounded" :content-align="contentAlign[0]" :legend-align="legendAlign[0]" :class="['mt-4']" :legend="legend ? $lang.termsOfService : null">
            <lorem-ipsum :repeats="3" :class="['text-sm']" />
          </form-group>
        </async-form>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageFormGroup',
  data () {
    return {
      titles: [{
        text: 'Mr.',
        value: 'mr'
      }, {
        text: 'Ms.',
        value: 'ms'
      }, {
        text: 'Mrs.',
        value: 'mrs'
      }],
      legend: true,
      rounded: true,
      legendAlign: ['left'],
      contentAlign: ['left'],
      formData: {
        firstName: '',
        lastName: '',
        title: []
      }
    }
  },
  computed: {
    legendAlignOptions () {
      return ['auto', 'left', 'center', 'right'].map(value => {
        return {
          value,
          text: this.$lang.legendAlign(value)
        }
      })
    },
    contentAlignOptions () {
      return ['auto', 'left', 'center', 'justify', 'right'].map(value => {
        return {
          value,
          text: this.$lang.contentAlign(value)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/forms/form-group.vue